import { render, staticRenderFns } from "./FpuiStars.vue?vue&type=template&id=2e7ecba0&lang=pug&"
import script from "./FpuiStars.vue?vue&type=script&lang=js&"
export * from "./FpuiStars.vue?vue&type=script&lang=js&"
import style0 from "./FpuiStars.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports